import { Component, inject, Input, OnInit } from '@angular/core';
import { SlideModalController } from '../../../../../../slide-modal.service';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { FormBuilder, FormGroup } from '@angular/forms';
import { P00037ESPPolariteComponent } from '../../EnSavoirPlus/p00037-esppolarite/p00037-esppolarite.component';
import { TwoChoicesModalComponent } from '../../../../../../../components/ecosystems/two-choices-modal/two-choices-modal.component';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { SwitchConfigurationComponent } from '../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00037DureeInversion } from '../../Enum/P00037DureeInversion';
import { P00037CellModel } from '../../Enum/P00037CellModel';

@Component({
  selector: 'app-p00037-installation-cellule-qrcode',
  templateUrl: './p00037-installation-cellule-qrcode.component.html',
  styleUrls: ['./p00037-installation-cellule-qrcode.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    SwitchConfigurationComponent,
    TranslatePipe,
  ],
})
export class P00037InstallationCelluleQRCodeComponent implements OnInit {
  private slideModalController = inject(SlideModalController);
  private modalController = inject(ModalController);
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  value: number | null = null;

  constructor() {}

  selectValue(v: number) {
    this.value = v;

    for (let i = 0; i < P00037CellModel.length; i++) {
      if (P00037CellModel[i].ref === this.value) {
        this.actionStack!.editValue(
          P00039DataRxTxIndex.SALT_Installation,
          'elICaracteristiqueCelluleQRImax',
          P00037CellModel[i].v1,
          null,
        );
        this.actionStack!.editValue(
          P00039DataRxTxIndex.SALT_Installation,
          'elICaracteristiqueCelluleQRUmax',
          P00037CellModel[i].v2,
          null,
        );
        this.actionStack!.editValue(
          P00039DataRxTxIndex.SALT_Installation,
          'elICaracteristiqueCelluleQRVt',
          P00037CellModel[i].v3,
          null,
        );
        break;
      }
    }
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00037DureeInversion = P00037DureeInversion;
  protected readonly P00037CellModel = P00037CellModel;
}
